import React, { useState } from "react";
import { App } from "../firebase";
import { useHistory } from "react-router-dom";
import BigTitle from "../components/BigTitle";
import "../styles/mon-compte.scss";
import { setLanguage, getTranslation } from "firebase-error-translator";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { API_URL } from "../constant";
// normalement signup
const SignIn = () => {
  const history = useHistory();
  const [prenomx, setPrenom] = useState(null);
  const [nomx, setNom] = useState(null);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLading] = useState(false);
  const [message, setMessage] = useState(null);

  const db = App.firestore();

  setLanguage("fr");
  App.auth().languageCode = "fr";
  const signUp = () => {
    if (nomx == null || nomx === "") {
      alert("Votre nom est obligatoire");
      return;
    }

    if (prenomx == null || prenomx === "") {
      alert("Votre prénom est obligatoire");
      return;
    }

    if (phone == null || phone.length <= 10) {
      alert("Votre numéro de téléphone est obligatoire, format international");
      return;
    }
    if (email == null || email === "") {
      alert("Votre email est obligatoire");
      return;
    }
    if (password === "") {
      alert("Votre password est obligatoire");
      return;
    }
    if (!checked) {
      alert("Veuillez acceptez les CGUs");
      return;
    }

    setLading(true);
    App.auth()
      .createUserWithEmailAndPassword(email, password)
      .then((res) => {
        setLading(false);
        save();
        // App.auth()
        //   .currentUser.sendEmailVerification({
        //     url: window.location.origin + "/mon-compte",
        //   })
        //   .then(function (result) {
        //     // setLading(false);
        //     save();
        //   })
        //   .catch(function (error) {
        //     setLading(false);
        //     console.log("ou la gregory", error.code);
        //     alert(getTranslation(error.code));
        //   });
        //do something with the response
      })
      .catch((err) => {
        setLading(false);
        //do something with the error
        console.log("ici gregory", err.code);
        if (err.code === "auth/email-already-in-use") {
          alert("Cette email est déjà enregistrer, connectez-vous.");
        } else {
          alert(getTranslation(err.code));
        }
      });
  };

  const sendEmailWelcome = async (email) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      email: email,
      type: "bienvenue",
      subject: "Inscription chez On Fleek",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "email", requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          console.log("Email welcome send");
        }
      })
      .catch((err) => {
        console.log("Email welcome not send");
        console.log(err);
        // alert("Une erreur s'est produite");
      });
  };
  function removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  async function save() {
    const { currentUser: fuser } = App.auth();
    setLading(true);
    db.collection("users")
      .doc(fuser.uid)
      .set({
        uid: fuser.uid,
        email: fuser.email,
        isAdmin: false,
        prenom: prenomx.trim(),
        nom: nomx.trim(),
        environement: "prod",
        // window.location.hostname === "onfleek.re" ? "prod" : "dev",
        _create_At: new Date(),
      })
      .then(async () => {
        sendEmailWelcome(fuser.email);
        // console.log("result", result);
        fetch(API_URL + "create-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: fuser.email }),
        })
          .then((res) => res.json())
          .then((data) => {
            db.collection("users").doc(fuser.uid).update({
              customerStripeId: data.id,
              _update_At: new Date(),
            });
          });
        if (fuser && fuser.phoneNumber !== phone) {
          setLading(true);
          try {
            const verifier = new App.auth.RecaptchaVerifier(
              "recaptcha-container",
              {
                callback: (response) => console.log("callback", response),
                size: "invisible",
              }
            );
            const phoneProvider = new App.auth.PhoneAuthProvider();
            const id = await phoneProvider.verifyPhoneNumber(phone, verifier);
            const code = prompt(
              "Veuillez entrer le code qui vous a été envoyé"
            );
            const cred = App.auth.PhoneAuthProvider.credential(id, code);
            await fuser.updatePhoneNumber(cred);
            db.collection("users").doc(fuser.uid).update({
              phone: phone,
              _update_At: new Date(),
            });
            const container = document.querySelector("#recaptcha-container");
            removeAllChildNodes(container);
            setLading(false);
            // console.log("phone number changed", id, cred, fuser);
            alert("Un email de vérification a été envoyé.");
            history.push("/mon-compte#signup-successful");
          } catch (e) {
            const container = document.querySelector("#recaptcha-container");
            removeAllChildNodes(container);
            setLading(false);
            console.error(e);
            // alert(getTranslation(e.code));
            var id = fuser.uid;
            // console.log("delete", id);
            alert(
              "Votre numéro est obligatoire. Réessayer l'inscription avec votre numéro de téléphone."
            );
            db.collection("users")
              .doc(id)
              .delete()
              .then(() => {
                App.auth().currentUser.delete();
                window.location.reload();
              });
          }
        }
      })
      .catch((error) => {
        setLading(false);
        console.log("error", error);
        alert(getTranslation(error.code));
      });
  }

  return (
    <>
      <BigTitle title="Mon compte " />

      <div class="login-master">
        <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
          Vous avez déjà un compte ?
        </div>
        <div class="overlap-group-login2 content-sha">
          <a href="/mon-compte">
            <div class="bouton-stroke sign-ins border-2px-eerie-black">
              <div class="sinscrire raleway-bold-eerie-black-14px">
                Se connecter
              </div>
            </div>
          </a>
        </div>
        <div class="cest-votre-premire-fois raleway-bold-eerie-black-20px">
          Inscrivez-vous
        </div>
        <div class="overlap-group-login2 content-sha">
          {/* <div class="onglet-de-login">
              <img
                alt=""
                class="trac-213"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/trac--213-1@1x.png"
              />
            </div> */}
          <div
            class="groupe-27 parapgrah"
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              maxWidth: "100%",
            }}
          >
            <div class="groupe-2-1" style={{ marginTop: 10 }}>
              <input
                value={nomx}
                onChange={(e) => setNom(e.currentTarget.value)}
                class="email parapgrah"
                name="lastname"
                placeholder="Nom"
                style={{ width: 264, fontSize: "16px" }}
                autoComplete="family-name"
                required
              />
              <img
                alt=""
                class="lignelogin-1"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
              />
            </div>
            <div class="groupe-2-1" style={{ marginTop: 10, marginBottom: 20 }}>
              <input
                value={prenomx}
                onChange={(e) => setPrenom(e.currentTarget.value)}
                class="email parapgrah"
                name="name"
                placeholder="Prénom"
                style={{ width: 264, fontSize: "16px" }}
                autoComplete="given-name"
                required
              />
              <img
                alt=""
                class="lignelogin-1"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
              />
            </div>
            <div class="groupe-2">
              <PhoneInput
                country="RE"
                defaultCountry="RE"
                name="phone"
                autoComplete={false}
                placeholder="Téléphone"
                value={phone}
                required
                style={{ width: "80%", fontSize: "16px" }}
                className="oraleway-normal-silver-14px-nopadding"
                onChange={(e) => {
                  setPhone(e);
                  if (e != null) {
                    setMessage(isValidPhoneNumber(e) ? true : false);
                  } else {
                    setMessage(null);
                  }
                }}
              />
              <img
                alt=""
                class="lignelogin-1"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
              />
            </div>

            {message != null && (
              <span
                style={{
                  color: message ? "green" : "red",
                  fontSize: 10,
                  marginTop: 10,
                }}
              >
                {message ? "Valide" : "Invalide"}
              </span>
            )}
            <div class="groupe-2-1" style={{ marginTop: 10 }}>
              <input
                value={email}
                autoComplete={false}
                onChange={(e) => setEmail(e.currentTarget.value)}
                type={"email"}
                class="email parapgrah"
                name="email"
                placeholder="Email"
                required
              />
              <img
                alt=""
                class="lignelogin-1"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
              />
            </div>

            <div class="groupe-2-1" style={{ marginTop: 23 }}>
              <input
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                type={"password"}
                class="mot-de-passe parapgrah"
                name="mot-de-passe01"
                placeholder="Mot de passe"
                required
              />
              <img
                alt=""
                class="lignelogin-1"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
              />
            </div>
            <div style={{ marginTop: 23, display: "flex" }}>
              <input
                type={"checkbox"}
                id={"cgu"}
                name={"cgu"}
                checked={checked}
                onChange={(e) => setChecked(!checked)}
              />
              <p for="cgu" style={{ marginLeft: 10 }}>
                J’accepte les{" "}
                <a onClick={() => history.push("/cgu")}>
                  <u>CGU</u>
                </a>
                .
              </p>
            </div>
            <div class="overlap-group-login">
              <button
                class="btn-valider"
                onClick={signUp}
                disabled={loading}
                style={{
                  border: "none",
                  background: loading && "white",
                }}
              >
                <div
                  class="valider raleway-semi-bold-white-18px"
                  style={{
                    color: loading && "black",
                  }}
                >
                  {loading ? "Chargement ..." : "Valider"}
                </div>
              </button>
            </div>
            <div id="recaptcha-container" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
